import React from "react";
import dayjs from 'dayjs';
import FormatNumber from "../../../../components/FormatNumber";
import { FixedAssetHelper } from "../../Assets/View.helper";
import BukkuTooltip from "../../../../components/Tooltip";

// Also used in Fixed Assets
export const Helper = {
    renderName: ({ rowData }) => (
        <div className="indent-col BaseTable__row-cell-text">
            <BukkuTooltip title={rowData.name}>
                {rowData.name}
            </BukkuTooltip>
        </div>
    ),

    renderCode: ({ rowData }) => {
        if (rowData.colType === 'subtotal' || rowData.colType === 'total')
            return null;
        return (
            <div className="indent-col">
                { rowData.code || null}
            </div>
        );
    },

    renderDate: (date, rowData) => {
        if (rowData.colType === 'subtotal' || rowData.colType === 'total')
            return null;

        if (!date)
            return null;

        const dateMoment = dayjs(date, "YYYY-MM-DD");
        return dateMoment.isValid() ? dateMoment.format('DD/MM/YYYY') : undefined;
    },

    renderAmount: (rowData, amount, currencySymbol, showNullAsDash = false) => {
        const shouldHide = rowData?.colType === 'total' || rowData?.colType === 'subtotal';

        if (amount === '' || amount === undefined || amount === null)
            return (showNullAsDash && !shouldHide) ? '-' : null;

        return (
            <div className="amount-container">
                <div className="currency">{currencySymbol}</div>
                <div className="value">
                    <FormatNumber amount={amount || 0} />
                </div>
            </div>
        );
    },

    renderText: (text, rowData, indent) => {
        if (rowData.colType === 'total' || rowData.colType === 'subtotal')
            return null;

        return (
            <div className={indent ? 'indent-col' : ''}>
                {text || '-'}
            </div>
        );
    },

    // Below: Only in Fixed Assets
    renderDepreciationMethod: ({rowData}) => {
        if (rowData.colType === 'subtotal')
            return null;
        return FixedAssetHelper.getDepreciationMethod(rowData.depreciation_method);
    },

    renderDepreciationConvention: ({rowData}) => {
        if (rowData.colType === 'subtotal')
            return null;
        return FixedAssetHelper.getDepreciationConvention(rowData.depreciation_convention);
    },

    renderDepreciationRate: ({rowData}) => {
        if (rowData.colType === 'subtotal')
            return null;
        return rowData.depreciation_rate || '-';
    },

    renderStatus: ({rowData}) => {
        if (rowData.colType === 'subtotal')
            return null;

        return FixedAssetHelper.getStatus(rowData.status);
    },
};
